import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BiaMasterService {
  constructor(private restService: RequestService) {}

  getBiaTemplate(templateId): any {
    return this.restService
      .request('GET', '/api/v5/sa-bia-template-groups', {
        'saBiaTemplateId.equals': templateId,
      })
      .pipe(
        map((res: any) => {
          if (!(res && res.body && res.body.length)) {
            return [];
          }

          return res.body.reduce((all, entry) => {
            if (!all[entry.appBiaCategory.categoryID]) {
              all[entry.appBiaCategory.categoryID] = [];
            }
            all[entry.appBiaCategory.categoryID].push(entry);
            return all;
          }, {});
        })
      );
  }

  updateBiaTemplate(id, data: any) {
    return this.restService.request(
      'PUT',
      `/api/v5/sa-bia-templates/${id}`,
      data
    );
  }

  addBiaTemplateGroup(data) {
    return this.restService.request(
      'POST',
      '/api/v5/sa-bia-template-groups',
      data
    );
  }

  updateBiaTemplateGroup(id, data) {
    return this.restService.request(
      'PUT',
      `/api/v5/sa-bia-template-groups/${id}`,
      data
    );
  }

  updateImpactTemplate(id, data: any) {
    return this.restService.request(
      'PUT',
      `/api/v5/sa-impact-templates/${id}/update`,
      data
    );
  }

  deleteImpactTemplateGroup(impactId) {
    return this.restService.request(
      'DELETE',
      `/api/v5/sa-bia-impact-template-groups/deleteByImpactId/${impactId}`
    );
  }

  addImpactTemplateGroupData(data) {
    return this.restService.request(
      'POST',
      '/api/v5/sa-bia-impact-template-groups',
      data
    );
  }

  getImpactTemplateGroupData(id) {
    return this.restService.request(
      'GET',
      `/api/v5/sa-with-impact-templates/${id}`
    );
  }

  getImpactTemplate(id) {
    return this.restService.request(
      'GET',
      `/api/v5/sa-with-impact-templates/${id}`
    );
  }

  getImpactTemplates() {
    return this.restService.request('GET', '/api/v5/sa-impact-templates');
  }

  getImpactTemplatesByCriteria(options = {}) {
    return this.restService.request(
      'GET',
      '/api/v5/sa-impact-templates-all',
      options
    );
  }

  getOverrideRto(isActive = true) {
    return this.restService.request('GET', '/api/sa-override-rtos', {
      page: 0,
      size: 2147483647,
      'isEnabled.equals': true,
      'isActive.equals': isActive,
    });
  }

  getImpactTypes() {
    return this.restService.request('GET', '/api/v5/sa-impact-types');
  }

  getImpactValues() {
    return this.restService.request('GET', '/api/v5/sa-impact-values');
  }

  addRaInteranlQues(data) {
    return this.restService.request(
      'POST',
      '/api/v5/sa-internal-ra-questions',
      data
    );
  }

  getRaInternalQues() {
    return this.restService.request('GET', '/api/v5/sa-internal-ra-questions', {
      'isEnabled.equals': true,
    });
  }

  updateRaInternalQues(id, data) {
    return this.restService.request(
      'PUT',
      `/api/v5/sa-internal-ra-questions/${id}`,
      data
    );
  }

  deleteRaInternalQues(id, data) {
    return this.restService.request(
      'PUT',
      `/api/v5/sa-internal-ra-questions/${id}`,
      data
    );
  }

  getCriticalDef() {
    return this.restService.request('GET', '/api/v5/sa-criticality-defs', {
      page: 0,
      size: 2147483647,
      'isEnabled.equals': true,
      'isActive.equals': true,
    });
  }

  // MAO related services
  addMaos(data) {
    return this.restService.request('POST', '/api/v5/sa-maos', data);
  }

  updateMaos(id, data) {
    return this.restService.request('PUT', `/api/v5/sa-maos/${id}`, data);
  }

  deleteMao(id) {
    return this.restService.request('DELETE', `/api/v5/sa-maos/${id}`);
  }

  // RTO
  addRto(data) {
    return this.restService.request('POST', '/api/v5/sa-rtos', data);
  }

  updateRto(id, data) {
    return this.restService.request('PUT', `/api/v5/sa-rtos/${id}`, data);
  }

  deleteRto(id) {
    return this.restService.request('DELETE', `/api/v5/sa-rtos/${id}`);
  }
  // impact type

  addImpactTypes(data) {
    return this.restService.request('POST', '/api/v5/sa-impact-types', data);
  }

  updateImpactTypes(id, data) {
    return this.restService.request(
      'PUT',
      `/api/v5/sa-impact-types/${id}`,
      data
    );
  }

  deleteImpactType(id) {
    return this.restService.request('DELETE', `/api/v5/sa-impact-types/${id}`);
  }
  // impact value

  addImpactValue(data) {
    return this.restService.request('POST', '/api/v5/sa-impact-values', data);
  }

  updateImpactValues(id, data) {
    return this.restService.request(
      'PUT',
      `/api/v5/sa-impact-values/${id}`,
      data
    );
  }

  deleteImpactValue(id) {
    return this.restService.request('DELETE', `/api/v5/sa-impact-values/${id}`);
  }

  // impact template group
  addImpactTemplateGroup(data) {
    return this.restService.request(
      'POST',
      '/api/v5/sa-bia-impact-template-groups',
      data
    );
  }

  deleteImpactTemplateGroupById(id) {
    return this.restService.request(
      'DELETE',
      `/api/v5/sa-bia-impact-template-groups/${id}`
    );
  }
}
